import { useEffect } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useScreenStore } from '../../stores/useScreenStore';
import { useToast } from '../toast/useToast';

export function useScreenSocket() {

    const socket = useSocketStore(state => state.socket);
    const { warning } = useToast();
    
    useEffect(() => {

        if (!socket) {
            return;
        }

        const { setScreenBlocked } = useScreenStore.getState();

        const handleBlock = txt => {
            warning(txt);
            setScreenBlocked(true);
        };

        socket.on('screen-already-open', handleBlock);

        return () => {

            socket.off('screen-already-open', handleBlock);
        };

    }, [socket, warning]);
}